
import Vue from 'vue';
import type { PropOptions } from 'vue';
import type { PublicPortfolioConfiguration } from '@/types/graphql';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoCallout from '~/components/common/BravadoCallout/BravadoCallout.vue';
import BravadoToggle from '~/components/common/BravadoToggle/BravadoToggle.vue';
import ClientsForm from '~/components/partials/public-portfolio/PublicPortfolioClients/ClientsForm.vue';

export default Vue.extend({
  name: 'PublicPortfolioClientsModal',
  components: {
    ClientsForm,
    PublicPortfolioModal,
    BravadoButtonV3,
    BravadoCallout,
    BravadoToggle,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    } as PropOptions<PublicPortfolioConfiguration>,
  },
  methods: {
    onVisibilityChange(value: boolean): void {
      this.$emit('upsert', {
        configurationAttrs: {
          sectionClientsIsPublic: value,
        },
      });
    },
  },
});
